"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VidConnectionCircleIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><rect width="2" height="8" x="14" y="8" fill="inherit" rx="1"/><rect width="2" height="6" x="11" y="10" fill="inherit" rx="1"/><rect width="2" height="3" x="8" y="13" fill="inherit" rx="1"/></g></svg>`
}, props));
VidConnectionCircleIcon.displayName = 'VidConnectionCircleIcon';
var _default = exports.default = VidConnectionCircleIcon;